// assets
import { IconCoin } from '@tabler/icons';
import CoinAoneDark from '../assets/images/CoinAoneDark';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CampaignIcon from '@mui/icons-material/Campaign';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ArticleIcon from '@mui/icons-material/Article';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import PaymentsIcon from '@mui/icons-material/Payments';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import PlaylistAddCheckCircleIcon from '@mui/icons-material/PlaylistAddCheckRounded';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
// constant
const icons = {
    IconCoin,
    CoinAoneDark,
    SummarizeIcon,
    CardGiftcardIcon,
    CampaignIcon,
    CreditCardIcon,
    ArticleIcon,
    FolderOpenIcon,
    PaymentsIcon,
    PriceCheckIcon,
    PlaylistAddCheckCircleIcon,
    FileDownloadIcon,
    WhatsAppIcon
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

function children() {
    const children = [];
    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        if (Roles.includes('31')) {
            children.push({
                id: 'exchangerate',
                title: 'Exchange Rate',
                type: 'item',
                url: '/financial/exchangerate',
                target: false,
                icon: icons.IconCoin
            });
        }

        if (Roles.includes('34')) {
            children.push({
                id: 'aonewallet',
                title: 'Aone Wallet Controller',
                type: 'item',
                url: '/financial/aonewallet',
                target: false,
                icon: icons.CoinAoneDark
            });
            children.push({
                id: 'aonewalletHistory',
                title: 'AoneWallet History',
                type: 'item',
                url: '/financial/aonewallet/history',
                target: false,
                icon: icons.SummarizeIcon
            });
            children.push({
                id: 'creditnoterequirement',
                title: 'Credit Note',
                caption: 'Top up',
                type: 'item',
                url: '/financial/aonewallet/credit',
                target: false,
                icon: icons.CardGiftcardIcon
            });
            children.push({
                id: 'creditInvoice',
                title: 'Credit Invoice',
                type: 'collapse',
                target: false,
                icon: icons.CreditCardIcon,
                children: [
                    {
                        id: 'creditInvoice-Controller',
                        title: 'CreditInvoice Controller',
                        caption: 'Pay of debt',
                        type: 'item',
                        url: '/financial/aonewallet/creditinvoice',
                        icon: icons.PaymentsIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'creditInvoice-verify',
                        title: 'Invoice Requirement',
                        caption: 'Verify & Check',
                        type: 'item',
                        url: '/financial/aonewallet/Verify/creditinvoice',
                        icon: icons.PriceCheckIcon,
                        breadcrumbs: false
                    },
                    // {
                    //     id: 'cashback-verify',
                    //     title: 'Verify Cashback',
                    //     caption: 'Cashback (no credit)',
                    //     type: 'item',
                    //     url: '/financial/aonewallet/Verify/cashback',
                    //     icon: icons.PriceCheckIcon,
                    //     breadcrumbs: false
                    // },
                    // {
                    //     id: 'qrpayment-verify',
                    //     title: 'QR Payment Verify',
                    //     caption: 'Finance verify LaoQR',
                    //     type: 'item',
                    //     url: '/financial/aonewallet/verify/qrpayment',
                    //     icon: icons.PriceCheckIcon,
                    //     breadcrumbs: false
                    // }
                ]
            });
            children.push({
                id: 'announcementrequest',
                title: 'Announcement Requirement',
                type: 'item',
                url: '/financial/aonewallet/announcement',
                target: false,
                icon: icons.CampaignIcon
            });
            children.push({
                id: 'claimcheck',
                title: 'Claim Check',
                type: 'item',
                url: '/financial/claimcheck',
                target: false,
                icon: icons.PlaylistAddCheckCircleIcon
            });
            children.push({
                id: 'cashback-verify',
                title: 'Cashback verify',
                caption: 'Cashback (no credit)',
                type: 'item',
                url: '/financial/aonewallet/Verify/cashback',
                target: false,
                icon: icons.PriceCheckIcon
            });
             children.push({
                id: 'qrpayment-verify',
                title: 'Finance verify LaoQR',
                type: 'item',
                url: '/financial/aonewallet/verify/qrpayment',
                target: false,
                icon: icons.PriceCheckIcon
            });
             children.push({
                id: 'stockimportlist',
                title: 'Verification Stock Import',
                type: 'item',
                url: '/financial/stockimportlist',
                target: false,
                icon: icons.FileDownloadIcon
            });
            children.push({
                id: 'whatsapp',
                title: 'WhatsApp',
                type: 'item',
                url: '/financial/whatsapp',
                target: false,
                icon: icons.WhatsAppIcon
            });
            children.push({
                id: 'reports-finance',
                title: 'Finance Report',
                type: 'collapse',
                icon: icons.FolderOpenIcon,
                children: [
                    {
                        id: 'reports-aging-creditinvoice',
                        title: 'CreditInvoice Aging Report',
                        type: 'item',
                        url: '/financial/report/agingcreditinvoice',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-usage-creditnote',
                        title: 'CreditNote Usage Report',
                        type: 'item',
                        url: '/financial/report/creditnoteusage',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-usage-credithistory',
                        title: 'CreditNote History Report',
                        type: 'item',
                        url: '/financial/report/credithistory',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-usage-creditinvoicehistory',
                        title: 'Creditinvoice History Report',
                        type: 'item',
                        url: '/financial/report/creditinvoicehistory',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-finance-saleandstockcompare',
                        title: 'SaleAndStock Compare Report',
                        type: 'item',
                        url: '/financial/report/saleandstockcompare',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    },
                    {
                        id: 'reports-finance-saleandstockmovement',
                        title: 'SaleAndStock Movement Report',
                        type: 'item',
                        url: '/financial/report/saleandstockmovement',
                        icon: icons.ArticleIcon,
                        breadcrumbs: false
                    }
                ]
            });
        }
    }
    return children;
}
const finance = {
    id: 'financial',
    title: 'Financial',
    type: 'group',
    children: children()
};

export default finance;
